<template>
    <section :class="`editor-box w-100 position-relative ${showEmptyMsgError ? 'pt-2' : ''}`">
        <span class="fw-bold text-danger ps-3" v-if="showEmptyMsgError">Please type a message to continue.</span>
        <span class="fw-bold text-danger" v-if="showAttachmentLimitError"
            >Maximum of 25 attachments may be added to a message.</span
        >
        <div class="d-flex attachment-error-div" v-if="showDuplicateAttachmentError">
            <span class="fw-bold text-danger"> This file is already attached to your message.</span>
            <button
                type="button"
                class="me-2 mb-2 close close-icon text-danger"
                @click="showDuplicateAttachmentError = false"
            >
                <img src="../../../../assets/images/red-cancel.svg" />
            </button>
        </div>
        <div class="d-flex important-div" v-if="isImportant">
            <span class="fw-bold text-danger"> IMPORTANT!</span>
        </div>
        <div
            class="d-flex important-div reply-div align-items-center"
            :ref="`${refsName}-replyMsg`"
            v-if="replyMessage"
        >
            <div class="card bg-form-section material-card my-1 reply-message-body">
                <div class="d-flex w-100 justify-content-between">
                    <span class="message-info">
                        <span class="me-2">
                            {{ replyMessage.senderDetails.firstName }}
                            {{ replyMessage.senderDetails?.lastName ? replyMessage.senderDetails?.lastName : "" }}
                        </span>
                        <span class="me-2"> {{ formatMessageTime(replyMessage.modifiedOn) }}</span>
                    </span>
                    <span class="ms-1 cursor-pointer" @click="cancelReply"
                        ><img src="../../../../assets/images/chat/cancel.svg"
                    /></span>
                </div>
                <span
                    v-if="replyMessage.text"
                    class="reply-message-text my-1"
                    v-html="sanitizeMarkup(markdownToHtml(replyMessage.text))"
                ></span>
                <span v-else-if="replyMsgProfiles">
                    <span
                        v-for="profile in replyMsgProfiles"
                        :key="profile.id"
                        class="d-inline-flex align-items-center justify-content-center share-profile me-1 mb-1 py-1 px-2"
                    >
                        <i class="fas fa-user-circle fa-lg pe-1"> </i>
                        <span> {{ profile.name }} </span>
                    </span>
                </span>
            </div>
        </div>
        <div
            :class="`d-flex text-editor ${selectedConversation?.hasUserLeftChat ? 'disable-editor' : ''} ${
                isImportant || showDuplicateAttachmentError || replyMessage ? 'header-added' : ''
            } ${expandFilePreview || expandProfilesPreview ? 'flex-column' : 'align-items-end'} ${
                showEmptyMsgError ? 'mt-1' : ''
            }`"
        >
            <section :ref="`${refsName}-textMarkup`"></section>
            <template
                v-if="
                    !(expandFilePreview || expandProfilesPreview) &&
                    (refsName === 'chatEditorRef' || refsName.includes('threadEditorRef-'))
                "
            >
                <div class="divider"></div>
                <img
                    :class="`send-btn cursor-pointer ${disableSend ? 'disableSend' : ''}`"
                    src="../../../../assets/images/chat/send.svg"
                    @click="send()"
                />
            </template>
            <div v-show="expandFilePreview || expandProfilesPreview">
                <div class="d-flex justify-content-between">
                    <div>
                        <div v-if="expandProfilesPreview" class="ps-2">
                            <span
                                v-for="profile in allSelectedProfiles"
                                :key="profile.agencyId"
                                class="d-inline-flex align-items-center justify-content-center share-profile me-1 mb-1 py-1 px-2"
                            >
                                <i class="fas fa-user-circle fa-lg pe-1"> </i>
                                <span v-if="profile?.name"> {{ profile.name }} </span>
                                <span v-else> {{ profile.lastName + " " + profile.firstName }} </span>
                                <i
                                    data-actionType="remove"
                                    class="fas fa-times-circle fa-md remove-profile-icon ps-2 pt-0 cursor-pointer"
                                    @click="removeProfile(profile)"
                                ></i>
                            </span>
                        </div>
                        <div v-show="expandFilePreview" id="MessageCenter__Files">
                            <section class="files-choice" v-for="file in filesUI" :key="file.fileName">
                                <i :class="`far ${file.iconClass} me-2`"></i>
                                <span>{{ truncateString(file.fileName, 30) }}</span>
                                <i class="fa fa-times ms-2 cursor-pointer" @click="removeFile(file.fileName)"></i>
                            </section>
                            <input
                                type="file"
                                multiple
                                accept="image/*, .pdf, .doc, .docx"
                                @change="uploadFilesChanged($event)"
                                :files="uploadFile"
                                class="fileInput"
                                :ref="`${refsName}-uploadMarkup`"
                                hidden
                            />
                        </div>
                    </div>

                    <div class="d-flex" v-if="refsName === 'chatEditorRef'">
                        <div class="divider"></div>
                        <img
                            :class="`send-btn cursor-pointer align-self-end ${shouldDisableSend ? 'disableSend' : ''}`"
                            src="../../../../assets/images/chat/send.svg"
                            @click="send()"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div :ref="`${refsName}-toolbar`" class="editor-toolbar" :class="`${refsName}-editor-toolbar`"></div>
    </section>
</template>
<style lang="scss" src="./SummerEditor.scss"></style>
<script lang="ts" src="./SummerEditor"></script>
